import { ref } from "vue";

export const showAlertValidateProductHappy = ref<boolean>(false);